import React from "react";

const ProgressBar = ({ step, totalSteps }) => {
    const percentage = Math.round((step / totalSteps) * 100);

    return (
        <div className="flex flex-col w-full gap-3 mt-4">
            <div className="flex items-center justify-between">
                <p className="text-gray-500 font-normal leading-relaxed">
                    Step {step} of {totalSteps}
                </p>
                <p className="text-gray-500 font-normal leading-relaxed">
                    {percentage}% Complete
                </p>
            </div>
            {/* Progress bar */}
            <div className="w-full h-3 rounded-full" style={{ backgroundColor: "#F4F7F7" }}>
                <div
                    className="h-3 rounded-full bg-primary"
                    style={{ width: `${percentage}%` }}
                />
            </div>
        </div>
    );
};

export default ProgressBar;
